import {
  useDelete,
  useGetWithCount,
  usePost,
  usePut,
} from "../common/fetchServices";
import { AUTH_BASE_URL } from "../props";
import { notBlank } from "../util/ext";
import { pickBy } from "ramda";
import querystring from "querystring";

const LIMIT = 10;

const getAuthTypeUrl = ({ organizationId, type }) =>
  `${AUTH_BASE_URL}/organizations/${organizationId}/authentication/${type}`;
const getBarcodePrefixUrl = ({ organizationId, type }) =>
  `${AUTH_BASE_URL}/organizations/${organizationId}/authentication/${type}/prefixes`;
const getAuthUrl = ({ organizationId, type, id }) =>
  `${AUTH_BASE_URL}/organizations/${organizationId}/authentication/${type}/${id}`;

const getAuthenticationsUrl = (
  filter,
  types,
  organization,
  orderBy,
  offset,
  limit,
) => {
  const params = pickBy((val, _key) => notBlank(val), {
    filter,
    types,
    org: organization,
    order: orderBy,
    offset,
    limit,
  });

  return `${AUTH_BASE_URL}/admin/authentication?${querystring.encode(params)}`;
};

export const useAdminAuthentication = (
  filter,
  types,
  organization,
  orderBy,
  page,
  limit = LIMIT,
) => {
  const offset = page * limit;
  const url = getAuthenticationsUrl(
    filter,
    types,
    organization,
    orderBy,
    offset,
    limit,
  );

  return useGetWithCount(["authentications", { url }], url);
};

export const useAuthenticationCreate = () => {
  return usePost(getAuthTypeUrl, {
    queriesToInvalidate: [["authentications"]],
  });
};

export const useAuthenticationUpdate = () => {
  return usePut(getAuthTypeUrl, {
    queriesToInvalidate: [["authentications"]],
  });
};

export const useBarcodePrefixUpdate = () => {
  return usePut(getBarcodePrefixUrl, {
    queriesToInvalidate: [["authentications"]],
  });
};

export const useAuthenticationDelete = () => {
  return useDelete(getAuthUrl, {
    queriesToInvalidate: [["authentications"]],
  });
};

export const authTypes = [
  { value: "region", display: "Geolocation" },
  { value: "ip", display: "IP" },
  { value: "ezproxy", display: "EzProxy" },
  { value: "referer", display: "Referer" },
  { value: "sip", display: "SIP" },
  { value: "papi", display: "Patron API" },
  { value: "barcode", display: "Barcode" },
  { value: "shibboleth", display: "Shibboleth" },
  { value: "scope", display: "Scope Only" },
];
